module.exports = __webpack_public_path__ + "images/category_lp/camera/new/store_images/2@2x_fb0da641e8f02453e98cdaefb651fa5b.png";